<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i class="pi pi-upload title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{ 'misc.importTriggersCsv' | transloco }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="grid">
      <div class="flex flex-column col-12">
        <p-panel [(collapsed)]="infoCollapsed" [toggleable]="true" class="mb-4 card p-0"
                 styleClass="p-panel-white-header">
          <ng-template pTemplate="header">
            <div class="flex align-items-center p-2">
              <i class="pi pi-info-circle text-xl"></i>
              <p class="ml-2 mb-0 text-xl" style="margin-top: 1px;">{{ 'common.information' | transloco }}</p>
            </div>
          </ng-template>
          <div class="flex">
            <ul class="mt-0 mb-1">
              <li class="line-height-3">{{ 'info.importCsv.format' | transloco }}</li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.fieldsInfo' | transloco }}</li>
              <div class="mt-2 mb-2">
                <i class="font-medium">{{ 'info.importTriggersCsv.fields.name' | transloco }} ,
                  {{ 'info.importTriggersCsv.fields.entityType' | transloco }} ,
                  {{ 'info.importTriggersCsv.fields.entityIdentifier' | transloco }} ,
                  {{ 'info.importTriggersCsv.fields.sensorName' | transloco }} ,
                  {{ 'info.importTriggersCsv.fields.operation' | transloco }} ,
                  {{ 'info.importTriggersCsv.fields.value' | transloco }},
                  {{ 'info.importTriggersCsv.fields.triggerType' | transloco }},
                  {{ 'info.importTriggersCsv.fields.category' | transloco }},
                  {{ 'info.importTriggersCsv.fields.disabledRepeatedEvent' | transloco }}
                </i>
              </div>
              <li class="line-height-3">{{ 'info.importTriggersCsv.name' | transloco }}</li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.entityType' | transloco }}</li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.entityIdentifier' | transloco }}</li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.sensorName' | transloco }}</li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.operation' | transloco }}
                <ul>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.operations.byteMask' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.operations.eq' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.operations.gt' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.operations.gte' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.operations.inactivity' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.operations.lt' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.operations.lte' | transloco }}</li>
                </ul>
              </li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.triggerType' | transloco }}
                <ul>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.triggerTypes.system' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.triggerTypes.user' | transloco }}</li>
                </ul>
              </li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.category' | transloco }}:
                <ul>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.categories.alarm' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.categories.warning' | transloco }}</li>
                </ul>
              </li>
              <li class="line-height-3">{{ 'info.importTriggersCsv.disabledRepeatedEvent' | transloco }}:
                <ul>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.disabledRepeatedEvents.true' | transloco }}</li>
                  <li class="line-height-3">{{ 'info.importTriggersCsv.disabledRepeatedEvents.false' | transloco }}</li>
                </ul>
              </li>
            </ul>
          </div>
        </p-panel>

        <div class="grid mb-2">
          <div [ngClass]="files.length > 0 || filesUploaded ? 'col-12 md:col-3': 'col-12'">
            <div class="card h-20rem p-0">
              <app-upload-csv [fileExtensions]="['csv']" (onFileDropped)="this.processFiles($event)"
                              [disabled]="!this.loadedData"></app-upload-csv>
            </div>
          </div>

          <div *ngIf="filesUploaded" class="col-12 md:col-9">
            <div class="card h-20rem p-0">
              <div class="flex h-full ">
                <div class="flex m-auto">
                  <div class="w-full">
                    <div class="flex upload rounded-lg shadow-sm">
                      <div class="m-auto">
                        <div class="icon w-full flex">
                          <i class="pi pi-check-circle m-auto success-color"
                             style="font-size: 62px"></i>
                        </div>
                        <div class="text-center mt-4">
                          <p>{{ 'info.importCsv.uploaded' | transloco }}</p>
                          <button pButton class="md:mr-2 p-button-primary my-2 md:mb-0"
                                  [routerLink]="'/system/csv-history'">
                            {{ 'info.importCsv.seeStatus' | transloco }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="files.length > 0 && !filesUploaded" class="col-12 md:col-9">
            <div class="card overflow-auto" [ngStyle]="{'max-height': '20rem'}">
              <p-accordion>
                <p-accordionTab *ngFor="let fileData of files; index as fileIndex"
                                [disabled]="fileData.fileErrors == null">
                  <p-header class="w-full">
                    <div class="flex align-items-center justify-content-between w-full ml-2">
                      <div class="w-3rem">
                        <i *ngIf="fileData.fileErrors != null" class="pi pi-file danger-color"
                           style="font-size: 30px"></i>
                        <i *ngIf="fileData.fileErrors == null" class="pi pi-file success-color"
                           style="font-size: 30px"></i>
                      </div>
                      <div class="w-full flex">
                        <p class="mb-0 line-height-4">{{ fileData.file.name }}</p>
                        <p class="p-12 ml-4 mb-0 line-height-4 font-normal">{{
                            fileData.file.size / 1048576 | number:
                              '1.2-2'
                          }} MB</p>
                      </div>
                      <div class="w-3rem flex flex-column md:flex-row justify-content-end">
                        <button (click)="deleteAttachment(fileIndex)" pButton pRipple
                                class="p-button-rounded btn-danger-light pointer-events-auto"
                                style="cursor: pointer !important;" icon="pi pi-trash">
                        </button>
                      </div>
                    </div>
                  </p-header>
                  <p-content>
                    <div *ngIf="fileData.fileErrors != null">
                      <div class="my-3">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                             style="font-size: 22px"></i>
                          <div>
                            {{ 'error.importCsv.wrongFileFormat' | transloco }}
                          </div>
                        </h5>
                        <ul>
                          <li *ngFor="let lineError of fileData.fileErrors?.lines">
                            {{ 'error.importCsv.cannotImportTriggerOfLine' | transloco: {line: lineError + 1} }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </p-content>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>

        <div *ngIf="filesLoaded && !filesUploaded" class="card flex flex-column">
          <div class="card-header pt-1">
            <div class="flex w-full align-items-center justify-content-between">
              <div class="inline mb-1">
                <h4 class="mt-1 inline">{{ 'info.importTriggersCsv.triggersToImport' | transloco }}</h4>
              </div>
            </div>
          </div>
          <hr>

          <form [formGroup]="csvTriggerForm" *ngIf="csvTriggerForm">
            <div class="grid mb-3">
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label>{{ 'model.tenant' | transloco }} (*)</label>
                </div>
                <div class="col-12">
                  <p-dropdown
                    [placeholder]="'select.tenant' | transloco"
                    [options]="tenants"
                    [filter]="true"
                    (onChange)="onTenantChange($event)"
                    styleClass="w-full"
                    id="tenant"
                    optionLabel="name"
                    formControlName="tenant"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="organization">{{ 'model.organization' | transloco }}</label><br>
                </div>
                <div class="col-12">
                  <p-dropdown
                    [placeholder]="'select.organization' | transloco"
                    [options]="organizations"
                    [filter]="true"
                    [showClear]="true"
                    (onClear)="onClearOrganization()"
                    (onChange)="onOrganizationChange($event)"
                    styleClass="w-full"
                    id="organization"
                    optionLabel="name"
                    formControlName="organization"
                  ></p-dropdown>
                </div>
              </div>
            </div>
          </form>
          <div class="p-datatable p-component p-datatable-hoverable-rows">
            <p-table [(first)]="first"
                     [(rows)]="rows"
                     [paginator]="true"
                     [responsive]="true"
                     responsiveLayout="stack"
                     breakpoint="1700px"
                     [rowsPerPageOptions]="[10,25,50]"
                     [totalRecords]="totalTriggers"
                     [value]="triggers"
                     styleClass="p-datatable-striped"
                     dataKey="trigger.name">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.name' | transloco }} (*)</th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.entityType' | transloco }} (*)</th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.entityIdentifier' | transloco }} (*)</th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.sensorName' | transloco }} (*)</th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.operation' | transloco }} (*)</th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.value' | transloco }} (*)</th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.triggerType' | transloco }} </th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.category' | transloco }} </th>
                  <th scope="col">{{ 'info.importTriggersCsv.fields.disabledRepeatedEvent' | transloco }} </th>
                  <th scope="col" class="w-4rem">{{ 'attribute.state' | transloco }}</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-csvTriggerData let-expanded="expanded">
                <tr>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.name' | transloco }} (*)</span>
                    <span *ngIf="csvTriggerData.trigger?.name">{{ csvTriggerData.trigger?.name }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.name"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.entityType' | transloco }}
                      (*)</span>
                    <span *ngIf="csvTriggerData.trigger?.entityType">{{ csvTriggerData.trigger?.entityType }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.entityType"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.entityIdentifier' | transloco }}
                      (*)</span>
                    <span
                      *ngIf="csvTriggerData.trigger?.entityIdentifier">{{ csvTriggerData.trigger?.entityIdentifier }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.entityIdentifier"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.sensorName' | transloco }}
                      (*)</span>
                    <span *ngIf="csvTriggerData.trigger?.sensorName">{{ csvTriggerData.trigger?.sensorName }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.sensorName"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.operation' | transloco }}
                      (*)</span>
                    <span *ngIf="csvTriggerData.trigger?.operation">{{ csvTriggerData.trigger?.operation }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.operation"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.value' | transloco }} (*)</span>
                    <span *ngIf="csvTriggerData.trigger?.value">{{ csvTriggerData.trigger?.value }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.value"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.value' | transloco }}</span>
                    <span *ngIf="csvTriggerData.trigger?.triggerType">{{ (csvTriggerData.trigger?.triggerType === 'USER' ? 'common.user' : 'common.system') | transloco }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.triggerType"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.category' | transloco }}</span>
                    <span *ngIf="csvTriggerData.trigger?.triggerCategory">{{ (csvTriggerData.trigger?.triggerCategory === 'ALARM' ? 'model.triggerCategories.alarm' : 'model.triggerCategories.warning') | transloco }}</span>
                    <span *ngIf="!csvTriggerData.trigger?.triggerCategory"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'info.importTriggersCsv.fields.disabledRepeatedEvent' | transloco }}</span>
                    <span>{{ (csvTriggerData.trigger.triggerdisabledRepeatedEvents ? 'common.true' : 'common.false') | transloco }}</span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{ 'attribute.state' | transloco }}</span>
                    <div class="flex justify-content-center">
                      <div class="pr-4" *ngIf="csvTriggerData.status === 'CORRECT'">
                        <i class="pi pi-check-circle align-self-center success-color"
                           style="font-size: 22px"></i>
                      </div>
                      <div class="flex" *ngIf="csvTriggerData.status === 'ERROR'">
                        <button type="button" pButton pRipple [pRowToggler]="csvTriggerData"
                                class="p-button-text p-button-rounded p-button-plain">
                          <i class="pi pi-times-circle align-self-center danger-color"
                             style="font-size: 22px"></i>
                          <i class="align-self-center ml-2 line-height-3"
                             [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                             style="font-size: 0.7rem"></i>
                        </button>
                      </div>
                      <div class="pr-4" *ngIf="csvTriggerData.status === 'PROCESSING'">
                        <i class="pi pi-spin pi-spinner align-self-center"
                           style="font-size: 1.5rem"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="rowexpansion" let-csvTriggerData>
                <tr>
                  <td colspan="16">
                    <div class="overflow-auto w-full" [ngStyle]="{'max-height': '15rem'}">
                      <div class="my-3" *ngFor="let propertyErrors of csvTriggerData.errors | keyvalue">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                             style="font-size: 1.5rem"></i>
                          <div>
                            {{ this.triggerPropertiesErrors.getTranslation(propertyErrors.key) }}
                          </div>
                        </h5>
                        <ul>
                          <li *ngFor="let error of propertyErrors.value">
                            {{ 'error.importCsv.' + error.message | transloco: error.params }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="triggers.length == 0">
                  {{ 'pagination.empty'| transloco }}
                </div>
                <div class="flex align-items-center justify-content-between" *ngIf="totalTriggers > 0">
                  {{ 'pagination.showing' | transloco }} {{ first + 1 }}
                  {{ 'pagination.to' | transloco }} {{ (first + rows) >= totalTriggers ? totalTriggers : (first + rows) }}
                  {{ 'pagination.of' | transloco }} {{ totalTriggers }}
                  {{ (totalTriggers > 1 ? 'pagination.entries' : 'pagination.entry') | transloco }}
                </div>
              </ng-template>

            </p-table>
          </div>
          <div class="grid">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco"
                          [routerLink]="'/alarms/triggers'"
                          pButton
                          class="p-button-danger"
                          iconPos="right">
                  </button>
                  <p-button [label]="'common.import' | transloco"
                            [disabled]="this.filesWithoutErrors?.length === 0 || csvTriggerForm.invalid"
                            [loading]="uploadingTriggers"
                            (onClick)="confirmImport()"
                            styleClass="p-button-primary">
                  </p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
